export default [
  { id: 'AF', descripcion: 'AFGANISTAN' },
  { id: 'AL', descripcion: 'ALBANIA' },
  { id: 'DE', descripcion: 'ALEMANIA' },
  { id: 'DZ', descripcion: 'ALGERIA' },
  { id: 'AD', descripcion: 'ANDORRA' },
  { id: 'AO', descripcion: 'ANGOLA' },
  { id: 'AX', descripcion: 'ANGUILLA - BRITISH WEST INDIES' },
  { id: 'AG', descripcion: 'ANTIGUA Y BARBUDA' },
  { id: 'AN', descripcion: 'ANTILLAS HOLANDESAS' },
  { id: 'SA', descripcion: 'ARABIA SAUDITA' },
  { id: 'AR', descripcion: 'ARGENTINA' },
  { id: 'AM', descripcion: 'ARMENIA' },
  { id: 'AH', descripcion: 'ARUBA' },
  { id: 'AU', descripcion: 'AUSTRALIA' },
  { id: 'AT', descripcion: 'AUSTRIA' },
  { id: 'AZ', descripcion: 'AZERBAIYAN' },
  { id: 'BS', descripcion: 'BAHAMAS' },
  { id: 'BH', descripcion: 'BAHRAIN' },
  { id: 'BB', descripcion: 'BARBADOS' },
  { id: 'BE', descripcion: 'BELGICA' },
  { id: 'BZ', descripcion: 'BELICE' },
  { id: 'BY', descripcion: 'BIELORRUSIA' },
  { id: 'BO', descripcion: 'BOLIVIA' },
  { id: 'BA', descripcion: 'BOSNIA-HERZEGOVINA' },
  { id: 'BW', descripcion: 'BOTSWANA' },
  { id: 'BR', descripcion: 'BRASIL' },
  { id: 'IV', descripcion: 'BRITISH VIRGIN ISLANDS(U.S.A)' },
  { id: 'BN', descripcion: 'BRUNEI' },
  { id: 'BU', descripcion: 'BULGARIA' },
  { id: 'CB', descripcion: 'CABO VERDE' },
  { id: 'KH', descripcion: 'CAMBODIA' },
  { id: 'CA', descripcion: 'CANADA' },
  { id: 'CL', descripcion: 'CHILE' },
  { id: 'CN', descripcion: 'CHINA' },
  { id: 'CO', descripcion: 'COLOMBIA' },
  { id: 'KR', descripcion: 'COREA' },
  { id: 'CR', descripcion: 'COSTA RICA' },
  { id: 'CC', descripcion: 'CROACIA' },
  { id: 'CU', descripcion: 'CUBA' },
  { id: 'CY', descripcion: 'CYPRUS' },
  { id: 'DK', descripcion: 'DINAMARCA' },
  { id: 'EC', descripcion: 'ECUADOR' },
  { id: 'EG', descripcion: 'EGIPTO' },
  { id: 'SV', descripcion: 'EL SALVADOR' },
  { id: 'EA', descripcion: 'EMIRATOS ARABES' },
  { id: 'SK', descripcion: 'ESLOVAQUIA' },
  { id: 'EV', descripcion: 'ESLOVENIA' },
  { id: 'ES', descripcion: 'ESPANA' },
  { id: 'US', descripcion: 'ESTADOS UNIDOS' },
  { id: 'EE', descripcion: 'ESTONIA' },
  { id: 'FJ', descripcion: 'FIJI' },
  { id: 'PH', descripcion: 'FILIPINAS' },
  { id: 'FI', descripcion: 'FINLANDIA' },
  { id: 'FR', descripcion: 'FRANCIA' },
  { id: 'GE', descripcion: 'GEORGIA' },
  { id: 'GB', descripcion: 'GRAN BRETANA' },
  { id: 'GR', descripcion: 'GRECIA' },
  { id: 'GP', descripcion: 'GUADALUPE' },
  { id: 'GU', descripcion: 'GUATEMALA' },
  { id: 'GY', descripcion: 'GUAYANA' },
  { id: 'GW', descripcion: 'GUINEA BISSAU' },
  { id: 'GQ', descripcion: 'GUINEA ECUATORIAL' },
  { id: 'HT', descripcion: 'HAITI' },
  { id: 'NL', descripcion: 'HOLANDA' },
  { id: 'HN', descripcion: 'HONDURAS' },
  { id: 'HU', descripcion: 'HUNGRIA' },
  { id: 'IN', descripcion: 'INDIA' },
  { id: 'ID', descripcion: 'INDONESIA' },
  { id: 'IA', descripcion: 'IRAN' },
  { id: 'IR', descripcion: 'IRLANDA' },
  { id: 'IS', descripcion: 'ISLANDIA' },
  { id: 'KY', descripcion: 'ISLAS CAYMAN' },
  { id: 'IL', descripcion: 'ISRAEL' },
  { id: 'IT', descripcion: 'ITALIA' },
  { id: 'JM', descripcion: 'JAMAICA' },
  { id: 'JP', descripcion: 'JAPON' },
  { id: 'JDI', descripcion: 'JIUNDAI' },
  { id: 'JO', descripcion: 'JORDANIA' },
  { id: 'KE', descripcion: 'KENYA' },
  { id: 'KG', descripcion: 'KIRGUISTAN' },
  { id: 'KW', descripcion: 'KUWAIT' },
  { id: 'LA', descripcion: 'LAOS' },
  { id: 'LVS', descripcion: 'LESVOS' },
  { id: 'LV', descripcion: 'LETONIA' },
  { id: 'LB', descripcion: 'LIBANO' },
  { id: 'LI', descripcion: 'LIECHTENSTEIN' },
  { id: 'LT', descripcion: 'LITHUANIA' },
  { id: 'LU', descripcion: 'LUXEMBURGO' },
  { id: 'MG', descripcion: 'MADAGASCAR ISLAND' },
  { id: 'MY', descripcion: 'MALASIA' },
  { id: 'MW', descripcion: 'MALAWI' },
  { id: 'MV', descripcion: 'MALDIVAS' },
  { id: 'MT', descripcion: 'MALTA' },
  { id: 'MA', descripcion: 'MARRUECOS' },
  { id: 'MQ', descripcion: 'MARTINIQUE/ MARTINICA' },
  { id: 'MU', descripcion: 'MAURICIO' },
  { id: 'MR', descripcion: 'MAURITANIA' },
  { id: 'MX', descripcion: 'MEXICO' },
  { id: 'MC', descripcion: 'MONACO' },
  { id: 'MO', descripcion: 'MONGOLIA' },
  { id: 'ME', descripcion: 'MONTENEGRO' },
  { id: 'MZ', descripcion: 'MOZAMBIQUE' },
  { id: 'XX', descripcion: 'MUNDO' },
  { id: 'MM', descripcion: 'MYANMAR' },
  { id: 'NA', descripcion: 'NAMIBIA' },
  { id: 'NP', descripcion: 'NEPAL' },
  { id: 'NI', descripcion: 'NICARAGUA' },
  { id: 'NG', descripcion: 'NIGERIA' },
  { id: 'NO', descripcion: 'NORUEGA' },
  { id: 'NZ', descripcion: 'NUEVA ZELANDA' },
  { id: 'OM', descripcion: 'OMAN' },
  { id: 'PB', descripcion: 'PAISES BAJOS' },
  { id: 'PBJ', descripcion: 'PAISES BAJOS' },
  { id: 'PJ', descripcion: 'PAISES BAJOS' },
  { id: 'PK', descripcion: 'PAKISTAN' },
  { id: 'PA', descripcion: 'PANAMA' },
  { id: 'PG', descripcion: 'PAPUA NUEVA GUINEA' },
  { id: 'PY', descripcion: 'PARAGUAY' },
  { id: 'PE', descripcion: 'PERU' },
  { id: 'PF', descripcion: 'POLINESIA FRANCESA' },
  { id: 'PL', descripcion: 'POLONIA' },
  { id: 'PT', descripcion: 'PORTUGAL' },
  { id: 'PR', descripcion: 'PUERTO RICO' },
  { id: 'QA', descripcion: 'QATAR' },
  { id: 'CS', descripcion: 'REPUBLICA CHECA' },
  { id: 'RD', descripcion: 'REPUBLICA DOMINICANA' },
  { id: 'RW', descripcion: 'RUANDA' },
  { id: 'WA', descripcion: 'RUANDA' },
  { id: 'RO', descripcion: 'RUMANIA' },
  { id: 'SU', descripcion: 'RUSIA' },
  { id: 'SM', descripcion: 'SAN MARINO' },
  { id: 'SL', descripcion: 'SANTA LUCIA' },
  { id: 'SN', descripcion: 'SENEGAL' },
  { id: 'RS', descripcion: 'SERBIA' },
  { id: 'SC', descripcion: 'SEYCHELLES ISLANDS' },
  { id: 'SG', descripcion: 'SINGAPUR' },
  { id: 'SY', descripcion: 'SIRIA' },
  { id: 'AB', descripcion: 'SOUTH KOREA' },
  { id: 'SR', descripcion: 'SRI LANKA' },
  { id: 'SB', descripcion: 'ST. BARTHELEMY' },
  { id: 'SI', descripcion: 'ST. MARTIN / ST. MAARTEN' },
  { id: 'ZA', descripcion: 'SUDAFRICA' },
  { id: 'SE', descripcion: 'SUECIA' },
  { id: 'CH', descripcion: 'SUIZA' },
  { id: 'TW', descripcion: 'TAIWAN' },
  { id: 'TZ', descripcion: 'TANZANIA' },
  { id: 'TH', descripcion: 'THAILANDIA' },
  { id: 'TT', descripcion: 'TRINIDAD Y TOBAGO' },
  { id: 'TN', descripcion: 'TUNEZ' },
  { id: 'UT', descripcion: 'TURKMENISTAN' },
  { id: 'TC', descripcion: 'TURKS AND CAICOS' },
  { id: 'TR', descripcion: 'TURQUIA' },
  { id: 'UA', descripcion: 'UCRANIA' },
  { id: 'UG', descripcion: 'UGANDA' },
  { id: 'UE', descripcion: 'UNION EUROPEA' },
  { id: 'UY', descripcion: 'URUGUAY' },
  { id: 'UZ', descripcion: 'UZBEKISTAN' },
  { id: 'VE', descripcion: 'VENEZUELA' },
  { id: 'VN', descripcion: 'VIETNAM' },
  { id: 'ZM', descripcion: 'ZAMBIA' },
  { id: 'ZW', descripcion: 'ZIMBABWE' },
];
